import { Col, Row } from "react-bootstrap";
import { compose, withState } from "recompose";

import BudgetClientProjectReaffectForm from "./BudgetClientProjectReaffectForm";
import Button from "../../elements/CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import React from "react";
import SideModal from "../../elements/Modal/SideModal";
import _ from "lodash";
import { graphql } from "react-apollo";
import moment from "moment";

import Spinner from "../../elements/Spinner/Spinner";


class BudgetClientProjectReaffectSideModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        company: { id: props.companyId },
        newProjectId: null
      }
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.tiersId !== this.props.tiersId && this.props.tiersId !== null && this.props.tiersId !== undefined) {
      const variables = {
        companyId: this.props.companyId,
        tiersId: this.props.tiersId,
      };
      const res = this.props.getBudgetProjectsForATiers.refetch(variables);
    }
  }

  reaffect = async values => {
    // this.props.setWorkInProgress(true);

    // console.log("31 - values=", values);

    const variables = {
      companyId: values.company.id,
      tiersId: values.tiersId,
      projectId: values.projectId,
      newProjectId: values.withoutProject ? null : values.newProjectId
    };

    if (this.props.confirm) {
      this.props.confirm(variables);
    }
  };

  close = () => {
    // console.log("close.state", this.state);
    this.props.close();
  };

  render = () => {
    const {
      title,
      sideModalVisible,
      companyId,
      tiersId,
      sendNotification,
      intl,
      locale,
      formValues
    } = this.props;

    // console.log("61 - this.props=", this.props);

    // return (
    //   <div>
    //   </div>
    // );
    if (this.props.getBudgetProjectsForATiers && this.props.getBudgetProjectsForATiers.loading) {
      return <div></div>; //<Spinner size="lg" />;
    }

    const values = {
      ...this.state.initialValues,
      companyId,
      projectId: formValues && formValues.projectId
    };


    const projectName = this.props.formValues && this.props.formValues.budgetProject &&
      this.props.formValues.budgetProject.name || "";

    const tiersName = this.props.formValues && this.props.formValues.name || "";

    const titleProject =
      <span>
        {title}
        {" : "}
        <span style={{ fontWeight: "bold" }} >
          {(tiersName && tiersName + " / " || "") + projectName}
        </span>
      </span>

    return (
      <SideModal
        title={titleProject}
        width="wide"
        visible={sideModalVisible}
        handleClose={this.close}
        children={
          <React.Fragment>
            <BudgetClientProjectReaffectForm
              sendNotification={sendNotification}
              companyId={companyId}
              values={values}
              goBack={this.close}
              reaffect={this.reaffect}
              // workInProgress={this.props.workInProgress}
              cancel={this.close}
              intl={intl}
              projectName={projectName}
              reaffectableToClient={this.props.reaffectableToClient}
              projectId={this.props.formValues && this.props.formValues.budgetProject && this.props.formValues.budgetProject.id}
              tiersId={this.props.formValues && this.props.formValues.id}
              excludeIds={this.props.getBudgetProjectsForATiers.getBudgetProjects}
            />
          </React.Fragment>
        }
      />
    );
  };
}

// const workInProgress = withState("workInProgress", "setWorkInProgress", () => {
//   return false;
// });

export default compose(
  // workInProgress,
  graphql(Queries.getBudgetProjectsForATiers, { name: "getBudgetProjectsForATiers" }),
)(BudgetClientProjectReaffectSideModal);
